export default __webpack_public_path__ + "static/media/amorelie.8dee2c49.png";